<template>
  <main class="container">
    <h2>Our Travel Services</h2>
    <div class="row">
      <div class="col sm-12 md-6 lg-3 mb-2" v-for="(it, i) of itineraries" :key="`it=${i}`">
        <div class="img" @click="showItinerary(it)">
          <img :src="it.image" alt="" />

          <div class="overlay">
            <div class="content text-center">
              <p>{{ it.title }}</p>
              <button class="has-icon">
                <i class="material-icons">visibility</i>
                <span>Details</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <it-details :itinerary="activeItinerary" :active="isShowItinerary" @close="isShowItinerary = false" />
  </main>
</template>

<script>
import ItDetails from "./components/ItDetails.vue";

export default {
  components: { ItDetails },
  name: "Itineraries",
  data() {
    return {
      activeItinerary: null,
      isShowItinerary: false,

      itineraries: [
        {
          title: "Excursion Price List",
          subtitle: "Price lists for various excursions",
          image: require("@/assets/images/itineraries/ex.jpeg"),
        },
        // {
        //   title: "Experience The Indian Ocean",
        //   subtitle: "Wasini Island · Funzi Island · Chale Island · Diani",
        //   image: require("@/assets/images/itineraries/12.jpeg"),
        // },
        {
          title: "Overnight Safari",
          subtitle: "To Amboseli National Park From Nairobi",
          image: require("@/assets/images/itineraries/1.jpg"),
        },
        {
          title: "Overnight Safari",
          subtitle: "To Amboseli National Park",
          image: require("@/assets/images/itineraries/2.jpg"),
        },
        {
          title: "4 Days 3 Nights",
          subtitle: "Masai Mara & Lake Nakuru Safari",
          image: require("@/assets/images/itineraries/4.jpg"),
        },
        {
          title: "Overnight Safari",
          subtitle: "To Masai Mara National Reserve",
          image: require("@/assets/images/itineraries/5.jpg"),
        },
        {
          title: "5 Days Safari",
          subtitle: "To Masai Mara, Lake Nakuru & Lake Naivasha",
          image: require("@/assets/images/itineraries/6.jpg"),
        },
        {
          title: "7 Days 6 Nights",
          subtitle: "To Masai Mara, Lake Nakuru, Lake Naivasha & Amboseli",
          image: require("@/assets/images/itineraries/7.jpg"),
        },
        {
          title: "6 Days 5 Nights Private Safari",
          subtitle: "To Masai Mara, Lake Nakuru & Amboseli National Park",
          image: require("@/assets/images/itineraries/8.jpg"),
        },
        {
          title: "3 Days 2 Nights Private Safari",
          subtitle: "To Masai Mara",
          image: require("@/assets/images/itineraries/9.jpg"),
        },
        {
          title: "3 Days 2 Nights Safari",
          subtitle: "To Olpejeta Conservancy",
          image: require("@/assets/images/itineraries/10.jpg"),
        },
        {
          title: "Overnight Safari",
          subtitle: "To Olpejeta Conservancy",
          image: require("@/assets/images/itineraries/11.jpg"),
        },
      ],
    };
  },
  mounted() {
    const navbar = document.querySelector("nav");
    navbar.classList.remove("translucent");
  },
  methods: {
    showItinerary(itinerary) {
      this.activeItinerary = itinerary;
      this.isShowItinerary = true;
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  margin: 100px 0 40px;

  .img {
    height: 100%;
    max-height: 500px;
    margin-bottom: 0.5rem;
    position: relative;
    border-radius: 8px;
    overflow: hidden;

    .overlay {
      background: linear-gradient(transparent, darken($primary-color, 40));
    }

    .content {
      position: absolute;
      bottom: 1rem;
      left: 50%;
      transform: translateX(-50%);
      color: white;
      // background-color: $purple;

      button {
        margin: 0 auto;
      }
    }
  }
}
</style>